import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useBeModel } from "../beModel";
import { dictService } from "../../dict/dictService";


export function BaseBe() {
    const {
        loadData,
        setAccountBankType,
    } = useBeModel()

    useEffect(() => {
        dictService.dictItemDs('account-bank').then(ds => { setAccountBankType(ds) })
    }, [])
    
    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [])

    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

